import React, { useContext, useMemo } from 'react';
import styles from './DrawerCloseButton.module.scss';
import I18n from '../../I18n/I18n/I18n';
import DrawerContext from '../DrawerContext/DrawerContext';
export default function DrawerCloseButton(_ref) {
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? null : _ref$label,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? null : _ref$onClick;
  var context = useContext(DrawerContext);
  var toggleCollapse = context.toggleCollapse;
  var i18n = useMemo(function () {
    return !!label ? label : {
      id: '@dm/components.drawer.close',
      values: {
        name: context.label
      }
    };
  }, [label]);
  return /*#__PURE__*/React.createElement("button", {
    className: styles.button,
    onClick: onClick !== null ? onClick : toggleCollapse
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.srLabel
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: i18n
  })));
}